export enum OwnerTypesEnum {
  BUILDING = 'building',
}
